'use client';

/* eslint-disable react/no-array-index-key */
import { c as _c } from "react/compiler-runtime";
import { type CSSProperties, useRef } from 'react';
import { IconChevronLeft } from '@/ui/segments/landing/icons/icon-chevron-left';
import { IconChevronRight } from '@/ui/segments/landing/icons/icon-chevron-right';
import { styleBlockSmall, styleButtonHoverable } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import type { Contributor } from './data';
import styles from './contributors-navigation.module.css';
interface ContributorsNavigationProps {
  pages: Contributor[][];
  page: number;
  onPageChange(page: number): void;
}
const LETTER_WIDTH = 32;
const LETTER_MARGIN = 12;
export default function ContributorsNavigation(t0) {
  const $ = _c(17);
  const {
    pages,
    page,
    onPageChange
  } = t0;
  const refLetters = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => handleScroll(refLetters.current, +1);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleScrollRight = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => handleScroll(refLetters.current, -1);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleScrollLeft = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(styles.contributorsPanel, styleBlockSmall);
    t4 = {
      "--custom-width-letter": `${LETTER_WIDTH}px`,
      "--custom-margin-letter": `${LETTER_MARGIN}px`
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <button type="button" className={styles.chevron} onClick={handleScrollLeft} aria-label="Previous page"><IconChevronLeft /></button>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onPageChange || $[6] !== page || $[7] !== pages) {
    let t7;
    if ($[9] !== onPageChange || $[10] !== page) {
      t7 = (group, i) => {
        const style = {};
        if (i % 5 === 0) {
          style.scrollSnapStop = "always";
        }
        return <div className={styles.letter} key={`page-${i}`} style={style}><button className={styleButtonHoverable} type="button" disabled={page === i} onClick={() => onPageChange(i)}>{group[0].last_name.trim().charAt(0).toUpperCase()}</button></div>;
      };
      $[9] = onPageChange;
      $[10] = page;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t6 = pages.map(t7);
    $[5] = onPageChange;
    $[6] = page;
    $[7] = pages;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <div className={styles.container}><div className={styles.letters} ref={refLetters}>{t6}</div></div>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <button type="button" className={styles.chevron} onClick={handleScrollRight} aria-label="Next page"><IconChevronRight /></button>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <div className={t3} style={t4}><div className={styles.pages}>{t5}{t7}{t8}</div></div>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function handleScroll(div: HTMLDivElement | null, direction: number) {
  if (!div) return;
  const letterWidth = 5 * (LETTER_WIDTH + 2 * LETTER_MARGIN);
  const lettersPerPage = Math.floor(div.clientWidth / letterWidth);
  const pageWidth = letterWidth * lettersPerPage;
  const x = div.scrollLeft + direction * pageWidth;
  div.scrollTo({
    left: x,
    behavior: 'smooth'
  });
}